module.exports = __webpack_public_path__ + "img/9ab96f1.png";